<template>
  <v-row>
    <v-col cols="6">
      <v-card :loading="loading">
        <v-toolbar flat>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical />
          <v-spacer />
          <v-btn color="primary" dark class="mb-2" @click="$router.back()">
            Назад
          </v-btn>
        </v-toolbar>

        <content-blocks
          v-if="!loading"
          :id="id"
          :blocks="blocks"
          :lang="lang"
          @read="editBlock"
          @remove="removeBlock"
          @move="moveBlock"
        />
      </v-card>
    </v-col>
    <v-col class="floating">
      <p v-if="!activeBlock" class="text-center">
        Выберите блок для редактирования или создайте блок
      </p>
      <component
        :is="makeFormComponentName(activeBlock.type)"
        v-else
        :blocks="blocks"
        :data="activeBlock"
        @update="update"
      />
    </v-col>
  </v-row>
</template>

<script>
import transport from "../../mixins/transport";
import ContentBlocks from "../content/ContentBlocks";
import FormH2 from "./forms/FormH2";
import FormText from "./forms/FormText";
import FormImageText from "./forms/FormImageText";
import FormImage from "./forms/FormImage";
import FormYoutube from "./forms/FormYoutube";

export default {
  name: "Content",
  components: {
    ContentBlocks,
    FormH2,
    FormText,
    FormImageText,
    FormImage,
    FormYoutube
  },
  mixins: [transport],
  props: {
    id: {
      type: Number,
      required: true
    },
    lang: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      title: "Информация обновляется...",
      blocks: [],
      activeBlock: null
    };
  },
  created() {
    this.loadContent();
  },
  methods: {
    loadContent() {
      if (this.loading) return;
      this.loading = true;
      this.transport(
        "GET",
        "news/content/" + this.id,
        { lang: this.lang },
        (response) => {
          this.title = response.data.title;
          this.blocks = response.data.blocks;
        },
        this.showSnack,
        () => {
          this.loading = false;
        }
      );
    },
    makeFormComponentName(type) {
      type = this.camelize(type);
      return "Form" + type.charAt(0).toUpperCase() + type.substr(1);
    },
    editBlock(data) {
      data.lang = this.lang;
      this.activeBlock = null;
      this.$nextTick(() => {
        this.activeBlock = data;
      });
    },
    removeBlock(data) {
      this.loading = true;
      this.transport(
        "post",
        "news/block/remove/" + data.id,
        {},
        (response) => {
          this.blocks = response.data;
        },
        this.showSnack,
        () => {
          this.loading = false;
          if (this.activeBlock && this.activeBlock.id === data.id) {
            this.activeBlock = null;
          }
        }
      );
    },
    moveBlock(block, dir) {
      this.loading = true;
      this.transport(
        "post",
        "news/block/move/" + block.id,
        { dir },
        (response) => {
          this.blocks = response.data;
        },
        this.showSnack,
        () => {
          this.loading = false;
        }
      );
    },
    update(payload) {
      this.blocks = payload.blocks;
      const found = this.blocks.some((block) => {
        if (block.id === payload.id) {
          this.activeBlock = block;
          return true;
        }
        return false;
      });
      if (!found) this.activeBlock = null;
    },
    camelize(string) {
      return string.replace(/-./g, (x) => x[1].toUpperCase());
    }
  }
};
</script>

<style scoped>
.floating {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;

  overflow: auto;
  flex: 50%;
  max-width: 50%;
}

@media (min-width: 1264px) {
  .floating {
    flex: 0 0 calc((100% - 256px) / 2);
    max-width: calc((100% - 256px) / 2);
  }
}
</style>
